import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {PERMISSION_FEATURE_KEY, PermissionPartialState, PermissionState} from './permission.reducer';

import {PermissionEntity} from './permission.models';
import {Exception} from '../../../../../../core/models';

const getPermissionState = createFeatureSelector<PermissionPartialState, PermissionState>(PERMISSION_FEATURE_KEY);

const isLoading: MemoizedSelector<object, boolean> = createSelector(
  getPermissionState,
  (state: PermissionState) => state.isLoading
);

const getException: MemoizedSelector<object, Exception> = createSelector(
  getPermissionState,
  (state: PermissionState) => state.exception
);

const getItems: MemoizedSelector<object, PermissionEntity[]> = createSelector(
  getPermissionState,
  (state: PermissionState) => state.items
);

export const PermissionSelectors = {
  isLoading,
  getException,
  getItems,
};
